<template>
  <router-view />
  <div id="recaptcha-container" style="display: none"></div>
</template>
<script>
import { ref, onMounted, onUnmounted } from "vue";
import idleTimer from "./utils/idleTimer";
import { useRouter } from "vue-router";
import firebaseAuthService from "@/services/FirebaseAuthService";
import { RecaptchaVerifier } from "firebase/auth";
import { auth } from "./services/auth/auth.service";

export default {
  setup() {
    const router = useRouter();
    const userRole = ref("Operator_Admin"); // Fetch this from Vuex/Pinia/localStorage/API
    const sessionTimeouts = {
      DB_Cargo_Admin: 8 * 60 * 60 * 1000, // 30 minutes
      Operator_Admin: 8 * 60 * 60 * 1000,
      Operator_Dispatcher: 8 * 60 * 60 * 1000,
      Forwarder_Admin: 8 * 60 * 60 * 1000,
      Forwarder_Dispatcher: 8 * 60 * 60 * 1000,
      Driver: 8 * 60 * 60 * 1000, // 8 hours
    };

    let idleSession;

    function logoutUser() {
      console.log("Session expired. Logging out...");
      firebaseAuthService.logout();
      router.push("/login"); // Redirect to login
    }

    onMounted(() => {
      const timeout = sessionTimeouts[userRole.value] || 30 * 60 * 1000; // Default 30 min
      console.log(sessionTimeouts[userRole.value], userRole.value);
      idleSession = idleTimer(timeout, logoutUser);
      idleSession.startTimer();

      // Recaptcha

      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new RecaptchaVerifier(
          auth,
          "recaptcha-container",
          {
            size: "invisible",
            callback: () => {
              console.log("reCAPTCHA solved");
            },
          }
        );

        window.recaptchaVerifier.render();
      }
    });

    onUnmounted(() => {
      idleSession.stopTimer();
    });

    return {};
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
